module.exports = __webpack_public_path__ + "static/media/7.e1f4c40c.jpg";